import { MutableRefObject } from 'react';

import { useExperimentSearchParams, useExperimentsTranslations } from 'modules/experiments/hooks';
import { MetricOption } from 'modules/experiments/types';
import { getChartActions, getChartExportingOptions } from 'modules/productAnalytics/utils';
import { BUTTON_VARIANTS, IconButton } from 'ui/button';
import { Menu } from 'ui/menu';
import { Overflow } from 'ui/icons';
import { ALIGNMENT } from 'ui/selects';

import {
  PerformanceHeaderMetricsSection,
  PerformanceHeaderMetricsText,
  WideBasicSelect,
} from './Styled';

type HeaderMetricSectionProps = {
  chartRef: MutableRefObject<any>;
  options: MetricOption<string>[];
};

export const HeaderMetricSection = ({ chartRef, options }: HeaderMetricSectionProps) => {
  const { t, ct } = useExperimentsTranslations();
  const { selectedPerformanceOverTimeMetric, setSelectedPerformanceOverTimeMetric } =
    useExperimentSearchParams();

  const chartId = 'variantPerformance';
  const chartActions = getChartActions(chartId, chartRef);

  return (
    <PerformanceHeaderMetricsSection>
      <PerformanceHeaderMetricsText data-test="variant-performance-header-title">
        {t('monitor.performance.header.metrics')}
      </PerformanceHeaderMetricsText>
      <WideBasicSelect
        data-test="variant-performance-header-metric-select"
        options={options}
        defaultValues={selectedPerformanceOverTimeMetric}
        categoryLabels={t('variantTable.metrics.title', { returnObjects: true })}
        inputContent={{
          filterPlaceholder: t('variantTable.metrics.filterPlaceholder'),
        }}
        emptyStateText={t('variantTable.metrics.emptyStateText')}
        onSelect={(newSelectedMetric) =>
          setSelectedPerformanceOverTimeMetric(newSelectedMetric as string[])
        }
        isFullWidth
      />
      <Menu
        data-test="variant-performance-header-chart-actions"
        handleSelectionChange={(key: string) => chartActions[key]()}
        horizontalAlignment={ALIGNMENT.RIGHT}
        options={getChartExportingOptions(chartId, ct)}
      >
        <IconButton variant={BUTTON_VARIANTS.SECONDARY}>
          <Overflow />
        </IconButton>
      </Menu>
    </PerformanceHeaderMetricsSection>
  );
};
